<div class="portalnav wrapper por-ac-tracking'" [ngStyle]="{ height: height, width: width }" class="wrapper">
    @if (mapReady | async) {
    <section class="route-delivery">
        @if ((mapReady | async) && (noTrackingOrders$ | async) === false && (orderExistsWithNoAddress$ | async) === false) {
        <div class="header-container">
            <h2 class="theme-heading">{{ 'Equipment Tracking' | translate }}</h2>
            @if (isLiveTrackingFeatureEnabled) {
            <por-base-button theme="primary" (onclick)="openLivelink()" [disabled]="isLiveLinkLoading() || !liveLinkUrl()" [featureName]="'LiveGPSTracking'">
                <span porIcon icon="satellite" class="button-icon-start"></span>
                @if (!liveLinkUrl()) {
                {{ 'LiveGPSTrackingNotAvailable' | translate }}
                } @if (liveLinkUrl()) {
                {{ 'OpenLiveGPSTracking' | translate }}
                } @if (isLiveLinkLoading()) {
                <span porIcon icon="spinner" class="spinner position-relative button-icon-end"></span>
                } @if (liveLinkUrl()) {
                <span porIcon icon="openinnew" class="button-icon-end"></span>
                }
            </por-base-button>
            }
        </div>
        } @if ((mapReady | async) && (noTrackingOrders$ | async) === false && (orderExistsWithNoAddress$ | async) === false) {
        <div class="map-custom" [ngStyle]="{ height: mapHeight }">
            @if (mapReady | async) {
            <por-google-map [config]="inputs" [pushpins]="pushpins"></por-google-map>
            }
        </div>
        } @if (noTrackingOrders$ | async) {
        <div [ngStyle]="{ height: mapHeight }" class="not-tracking-order">
            <h2 class="theme-heading">{{ 'Sorry' | translate }} !</h2>
            <h3 class="theme-paragraph">
                {{ 'There are no open contracts to be able to map.' | translate }}
            </h3>
        </div>
        } @if (orderExistsWithNoAddress$ | async) {
        <div [ngStyle]="{ height: mapHeight }" class="not-tracking-order">
            <h2 class="theme-heading">{{ 'Sorry' | translate }} !</h2>
            <h3 class="theme-paragraph">{{ 'MissingOpenContractLocationDetail' | translate }}.</h3>
        </div>
        }
    </section>
    }
</div>
